import { debounce, isInViewport } from './utils/utils.js'

async function init (element, loadedItems) {
  let $this = createObject(element)
  $this.element.on('update', debounce(function () {update($this)}, 250))
  await initScrollMagic($this)

}

function createObject (element) {
  return {
    element: element,
    loadingContainer: element.find('.infinite-scrolling-animation'),
    items: element.find('.item-wrapper')
  }
}

function update ($this) {
  let items = $this.items.filter('[data-visible=false][data-filter-visible=true]')
  if (items.length > 0 && isInViewport($this.element.find('.infinite-scrolling-marker'))) {
    displayElements($this)
  }
}

async function initScrollMagic ($this) {
  const ScrollMagicLib = await import(/* webpackChunkName: "scrollmagic" */ 'scrollmagic/scrollmagic/uncompressed/ScrollMagic.js')
  const ScrollMagic = ScrollMagicLib.default
  $this.scrollMagicController = new ScrollMagic.Controller({
    addIndicators: false
  })

  $this.scrollMagicScene = new ScrollMagic.Scene({
    triggerElement: $this.element.find('.infinite-scrolling-marker')[0],
    triggerHook: 'onEnter'
  })
    .addTo($this.scrollMagicController)
    .on('enter', function () {
      displayElements($this)
    })
}

function displayElements ($this) {
  let items = $this.items.filter('[data-visible=false][data-filter-visible=true]')
  if (items.length > 0) {
    $this.loadingContainer.addClass('active')
    setTimeout(function () {
      items
        .slice(0, 9)
        .attr('data-visible', true)
        .show({
          effect: 'fade',
          complete: () => {
            $this.loadingContainer.removeClass('active')
            $this.element.trigger('update')
          }
        })
    }, 1000)
  } else {
    $this.loadingContainer.removeClass('active')
  }
}

export default init
